import { render, staticRenderFns } from "./saved-template-sidebar.html?vue&type=template&id=3eb531b6&scoped=true&"
import script from "./saved-template-sidebar.js?vue&type=script&lang=js&"
export * from "./saved-template-sidebar.js?vue&type=script&lang=js&"
import style0 from "./saved-template-sidebar.scss?vue&type=style&index=0&id=3eb531b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb531b6",
  null
  
)

export default component.exports